var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('span',{staticClass:"subtitle-2 font-weight-regular grey--text lighten-3"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',[_vm._v(_vm._s(_vm.text || "-"))])])
}
var staticRenderFns = []

export { render, staticRenderFns }